var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative h-0",style:(("padding-bottom: " + (_vm.aspectRatio * 100) + "%"))},[_c('canvas',{ref:"canvas",staticClass:"absolute top-0 left-0 right-0 bottom-0 w-full h-full",attrs:{"width":"32","height":"32"}})])}
var staticRenderFns = []

export { render, staticRenderFns }